import { c as _c } from "react/compiler-runtime";
import type { ApiProfileProxy } from "@/generated/models/ApiProfileProxy";
export default function HeaderUserProxyDropdownItem(t0) {
  const $ = _c(25);
  const {
    profileProxy,
    activeProfileProxy,
    onActivateProfileProxy
  } = t0;
  const isActive = profileProxy.id === activeProfileProxy?.id;
  const t1 = `${isActive ? "tw-bg-iron-700" : "tw-bg-transparent hover:tw-bg-iron-700"} tw-group tw-relative tw-flex tw-h-full tw-w-full tw-cursor-pointer tw-select-none tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-none tw-px-3 tw-py-2.5 tw-text-left tw-text-white tw-transition tw-duration-300 tw-ease-out focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400`;
  let t2;
  if ($[0] !== isActive || $[1] !== onActivateProfileProxy || $[2] !== profileProxy) {
    t2 = () => onActivateProfileProxy(isActive ? null : profileProxy);
    $[0] = isActive;
    $[1] = onActivateProfileProxy;
    $[2] = profileProxy;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== isActive || $[5] !== profileProxy.created_by.handle || $[6] !== profileProxy.created_by.pfp) {
    t3 = profileProxy.created_by.pfp ? <img src={profileProxy.created_by.pfp} alt={`${profileProxy.created_by.handle} avatar`} className="tw-h-6 tw-w-6 tw-flex-none tw-flex-shrink-0 tw-rounded-lg tw-bg-iron-800" /> : <div className={`${isActive ? "tw-bg-iron-600" : "tw-bg-iron-700 group-hover:tw-bg-iron-600"} tw-h-6 tw-w-6 tw-flex-none tw-flex-shrink-0 tw-rounded-lg tw-transition tw-duration-300 tw-ease-out`} />;
    $[4] = isActive;
    $[5] = profileProxy.created_by.handle;
    $[6] = profileProxy.created_by.pfp;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== profileProxy.created_by.handle) {
    t4 = <div className="tw-truncate tw-text-md tw-font-medium tw-text-white">{profileProxy.created_by.handle}</div>;
    $[8] = profileProxy.created_by.handle;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="tw-pl-2 tw-pr-0.5 tw-text-sm tw-font-normal tw-italic tw-text-iron-400">Proxy</span>;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4) {
    t6 = <div className="tw-inline-flex tw-items-center tw-justify-between tw-truncate">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== isActive) {
    t7 = isActive && <svg className="tw-ml-2 tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[13] = isActive;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t7) {
    t8 = <div>{t7}</div>;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t6 || $[18] !== t8) {
    t9 = <div className="tw-flex tw-w-full tw-items-center tw-justify-between">{t6}{t8}</div>;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t1 || $[21] !== t2 || $[22] !== t3 || $[23] !== t9) {
    t10 = <div className="tw-h-full"><button type="button" className={t1} onClick={t2}>{t3}{t9}</button></div>;
    $[20] = t1;
    $[21] = t2;
    $[22] = t3;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}